// @ts-nocheck
/**
 * roro-cart-wishlist-modal — Modal «Зберегти цей товар на потім?» al eliminar del carrito.
 *
 * Intercepta el click en .cart-items__remove dentro del cart drawer.
 * Presenta un modal con el producto y dos opciones:
 * 1. «Додати до списку бажань» -> Añade a wishlist (ROROWishlist.add) y elimina del carrito.
 * 2. «Ні, дякую» -> Elimina del carrito sin wishlist.
 * 3. X / Backdrop / ESC -> Elimina del carrito sin wishlist (la acción inicial era eliminar).
 */
(function () {
  'use strict';

  var activeModal = null;
  var isBypassing = false;

  var CLOSE_SVG =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
    '</svg>';

  /**
   * Ejecuta la eliminación de la línea en el carrito.
   * @param {HTMLElement} row
   * @param {number} lineIndex
   * @param {HTMLButtonElement|HTMLElement} [removeBtn]
   */
  function executeRemove(row, lineIndex, removeBtn) {
    var cartComponent = row.closest('cart-items-component');
    if (cartComponent && typeof cartComponent.onLineItemRemove === 'function') {
      cartComponent.onLineItemRemove(lineIndex);
      return;
    }

    if (removeBtn && typeof removeBtn.click === 'function') {
      isBypassing = true;
      removeBtn.click();
      isBypassing = false;
    }
  }

  /**
   * Cierra el modal activo y devuelve el foco si procede.
   */
  function closeModal() {
    if (!activeModal) return;
    var dialog = activeModal.dialog;
    var prevFocused = activeModal.prevFocused;

    if (dialog && dialog.parentNode) {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      }
      dialog.parentNode.removeChild(dialog);
    }

    activeModal = null;

    if (prevFocused && typeof prevFocused.focus === 'function' && prevFocused.isConnected) {
      prevFocused.focus();
    }
  }

  /**
   * Abre el modal de confirmación con opción a wishlist.
   * @param {object} data
   * @param {number} data.productId
   * @param {string} data.productHandle
   * @param {string} data.productTitle
   * @param {string} data.productImage
   * @param {number} data.lineIndex
   * @param {HTMLElement} data.row
   * @param {HTMLButtonElement|HTMLElement} data.button
   */
  function openSaveLaterModal(data) {
    closeModal();

    var hasExecuted = false;
    function runRemoval(addToWishlist) {
      if (hasExecuted) return;
      hasExecuted = true;

      if (addToWishlist && window.ROROWishlist && typeof window.ROROWishlist.add === 'function') {
        window.ROROWishlist.add(data.productId, data.productHandle);
      }

      closeModal();
      executeRemove(data.row, data.lineIndex, data.button);
    }

    var roroStrings = window.RORO_STRINGS || {};
    var titleText = (roroStrings.cart_save_later_title && roroStrings.cart_save_later_title.trim()) || 'Зберегти цей товар на потім?';
    var noText = (roroStrings.cart_save_later_no && roroStrings.cart_save_later_no.trim()) || 'Ні, дякую';
    var yesText = (roroStrings.cart_save_later_yes && roroStrings.cart_save_later_yes.trim()) || 'Додати до списку бажань';

    var dialog = document.createElement('dialog');
    dialog.className = 'roro-save-modal';
    dialog.setAttribute('aria-label', titleText);

    // Botón cerrar (X)
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'roro-save-modal__close';
    closeBtn.setAttribute('aria-label', 'Закрити');
    closeBtn.innerHTML = CLOSE_SVG;

    // Título
    var heading = document.createElement('h3');
    heading.className = 'roro-save-modal__title';
    heading.textContent = titleText;

    // Vista previa del producto
    var preview = document.createElement('div');
    preview.className = 'roro-save-modal__product';

    if (data.productImage) {
      var imgWrap = document.createElement('div');
      imgWrap.className = 'roro-save-modal__media';
      var img = document.createElement('img');
      img.src = data.productImage;
      img.alt = data.productTitle || '';
      img.className = 'roro-save-modal__img';
      imgWrap.appendChild(img);
      preview.appendChild(imgWrap);
    }

    var prodTitle = document.createElement('span');
    prodTitle.className = 'roro-save-modal__product-title';
    prodTitle.textContent = data.productTitle || '';
    preview.appendChild(prodTitle);

    // Acciones
    var actions = document.createElement('div');
    actions.className = 'roro-save-modal__actions';

    var noBtn = document.createElement('button');
    noBtn.type = 'button';
    noBtn.className = 'roro-save-modal__action-no';
    noBtn.textContent = noText;

    var yesBtn = document.createElement('button');
    yesBtn.type = 'button';
    yesBtn.className = 'roro-save-modal__action-yes';
    yesBtn.textContent = yesText;

    actions.appendChild(noBtn);
    actions.appendChild(yesBtn);

    dialog.appendChild(closeBtn);
    dialog.appendChild(heading);
    dialog.appendChild(preview);
    dialog.appendChild(actions);

    // 1. «Додати до списку бажань»
    yesBtn.addEventListener('click', function (e) {
      e.preventDefault();
      runRemoval(true);
    });

    // 2. «Ні, дякую»
    noBtn.addEventListener('click', function (e) {
      e.preventDefault();
      runRemoval(false);
    });

    // 3. Cerrar X
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      runRemoval(false);
    });

    // 4. Click backdrop
    dialog.addEventListener('click', function (e) {
      var rect = dialog.getBoundingClientRect();
      var isInDialog =
        rect.top <= e.clientY &&
        e.clientY <= rect.top + rect.height &&
        rect.left <= e.clientX &&
        e.clientX <= rect.left + rect.width;
      if (!isInDialog) {
        e.preventDefault();
        runRemoval(false);
      }
    });

    // 5. ESC nativo en dialog
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      runRemoval(false);
    });

    document.body.appendChild(dialog);

    activeModal = {
      dialog: dialog,
      prevFocused: document.activeElement,
      runRemoval: runRemoval,
      data: data
    };

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    // Focus inicial en el botón primario
    yesBtn.focus();
  }

  // Interceptar click en el botón de eliminar del drawer (fase de captura)
  document.addEventListener(
    'click',
    function (event) {
      if (isBypassing) return;

      var target = event.target;
      if (!(target instanceof Element)) return;

      var removeBtn = target.closest('.cart-items__remove');
      if (!removeBtn) return;

      var drawer = removeBtn.closest('.cart-drawer__dialog');
      if (!drawer) return; // Solo en cart drawer

      var row = removeBtn.closest('.cart-items__table-row');
      if (!row) return;

      var productId = parseInt(row.getAttribute('data-product-id') || '0', 10);
      var productHandle = row.getAttribute('data-product-handle') || '';
      var productTitle = row.getAttribute('data-product-title') || '';
      var productImage = row.getAttribute('data-product-image') || '';
      var lineIndex = parseInt(row.getAttribute('data-line-index') || '1', 10);

      // Si falta ID, permitir flujo normal
      if (!productId || !productHandle) return;

      // Interceptar acción
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openSaveLaterModal({
        productId: productId,
        productHandle: productHandle,
        productTitle: productTitle,
        productImage: productImage,
        lineIndex: lineIndex,
        row: row,
        button: removeBtn
      });
    },
    true
  );

  // Manejo de ESC y focus trap
  document.addEventListener(
    'keydown',
    function (event) {
      if (!activeModal) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        if (typeof activeModal.runRemoval === 'function') {
          activeModal.runRemoval(false);
        } else {
          var data = activeModal.data;
          closeModal();
          if (data) {
            executeRemove(data.row, data.lineIndex, data.button);
          }
        }
        return;
      }

      if (event.key === 'Tab') {
        var focusable = activeModal.dialog.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey) {
          if (document.activeElement === first) {
            event.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }
    },
    true
  );
})();
